import { Accordion, AccordionBody, AccordionHeader, AccordionItem } from 'reactstrap';
import './layers-viewer.css';
import { useRef } from 'react';
import { ModelNameHandler } from '../model-name-handler/model-name-handler';
import { LayerItemCard } from './layer-item-card/layer-item-card';
import { Project } from '../../../types/api/project/get-project-success-response';
import { LayerWithNewLayerItemTooAndChangeableSubmodelName, NewLayerithChangeableSubmodelName } from '../../../types/api/layer/layer';
import { getImageUrl } from '../../../../../utils/image-helper/get-image-url';
import { CMSButton } from '../../../../../components/cms/button/cms-button.';

type LayersViewerProps = {
    project: Project;
    layers: (LayerWithNewLayerItemTooAndChangeableSubmodelName | NewLayerithChangeableSubmodelName)[];
    selectedModelUUID: string | null;
    selectedLayerId: number | null;
    selectedLayerItemId: number | null;
    onLayerItemModelSelect: (uuid: string | null) => void;
    onLayerItemSelect: (layerItemId: number | null) => void;
    onLayerSelect: (layerId: number | null) => void;
    onNewLayerAdd: (id: number, name: string) => void;
    onNewLayerItemAdd: (id: number, layerId: number, name: string) => void;
    onLayerNameChange?: (layerId: number, name: string) => void;
    onLayerItemNameChange?: (layerItemId: number, name: string) => void;
    onLayerDelete?: (layerId: number) => void;
    onLayerItemDelete?: (layerItemId: number) => void;
    disabled: boolean;
    onModelSelectClick?: (layerItemId: number) => void;
    onOtherModelChooseClick?: (layerItemId: number) => void;
    onSubmodelSelectClick?: (layerItemId: number) => void;
    onOtherSubmodelChooseClick?: (layerItemId: number) => void;
    onSubmodelNameClick?: (layerItemId: number) => void;
    onSubmodelNameCancelClick?: (layerItemId: number) => void;
    onSubmodelNameSaveClick?: (layerItemId: number, name: string) => void;
};

export const LayersViewer = ({
    layers,
    selectedModelUUID,
    selectedLayerId,
    selectedLayerItemId,
    project,
    disabled,
    onNewLayerAdd,
    onNewLayerItemAdd,
    onLayerSelect,
    onLayerItemSelect,
    onLayerNameChange,
    onLayerItemNameChange,
    onLayerDelete,
    onLayerItemDelete,
    onModelSelectClick,
    onOtherModelChooseClick,
    onSubmodelSelectClick,
    onOtherSubmodelChooseClick,
    onSubmodelNameClick,
    onSubmodelNameCancelClick,
    onSubmodelNameSaveClick
}: LayersViewerProps) => {
    const newLayerIdRef = useRef(-1);
    const newLayerItemIdRef = useRef(-1);

    const handleAddNewLayerClick = () => {
        onNewLayerAdd(newLayerIdRef.current, `új réteg ${ newLayerIdRef.current * -1 }`);
        newLayerIdRef.current--;
    };

    const handleLayerItemAddClick = (layerId: number) => {
        onNewLayerItemAdd(newLayerItemIdRef.current--, layerId, `új elem ${ newLayerItemIdRef.current * -1 }`);
        newLayerItemIdRef.current--;
    };

    return (
        <div className='layers-viewer'>

            {
                disabled && (
                    <div className="loader">
                        <div className='spinner'>
                            <div className='spinner-border'></div>
                        </div>
                    </div>
                )
            }

            <Accordion
                className='layers-accordion'
                open={selectedLayerId ? selectedLayerId.toString() : ''}
                toggle={
                    (id) => {
                        if (id !== selectedLayerId?.toString()) onLayerSelect(parseInt(id, 10));
                        else onLayerSelect(null);
                    }
                }
            >
                {
                    layers.map(layer => (
                        <AccordionItem key={layer.id} className='mb-2'>
                            <AccordionHeader
                                targetId={layer.id!.toString()}
                                className="root-accordion-header"
                            >
                                <ModelNameHandler
                                    editIconColor='black'
                                    defaultValue={layer.name ?? ''}
                                    onSave={
                                        (name) => {
                                            if (onLayerNameChange) onLayerNameChange(layer.id, name);
                                        }
                                    }
                                />
                                <img
                                    src={getImageUrl('delete-icon.png')}
                                    alt="del"
                                    onClick={
                                        (e) => {
                                            e.stopPropagation();
                                            if (onLayerDelete) onLayerDelete(layer.id);
                                        }
                                    }
                                    title="Törlés"
                                />
                            </AccordionHeader>
                            <AccordionBody accordionId={layer.id.toString()} className='root-accordion-body'>
                                {
                                    layer.layerItems?.map((layerItem) => (
                                            <LayerItemCard
                                                project={project}
                                                key={layerItem.id}
                                                selectedModelUUID={selectedModelUUID}
                                                layerItem={layerItem}
                                                isOpen={layerItem.id === selectedLayerItemId}
                                                onOpenAccordion={() => onLayerItemSelect(layerItem.id)}
                                                onCloseAccordion={() => onLayerItemSelect(null)}
                                                onLayerItemDelete={
                                                    () => {
                                                        if (onLayerItemDelete) onLayerItemDelete(layerItem.id);
                                                    }
                                                }
                                                onLayerItemModelNameChange={
                                                    (name) => {
                                                        if (onLayerItemNameChange) onLayerItemNameChange(layerItem.id, name);
                                                    }
                                                }
                                                onModelSelectClick={
                                                    () => {
                                                        if (onModelSelectClick) onModelSelectClick(layerItem.id);
                                                    }
                                                }
                                                onOtherModelChooseClick={
                                                    () => {
                                                        if (onOtherModelChooseClick) onOtherModelChooseClick(layerItem.id);
                                                    }
                                                }
                                                onSubmodelSelectClick={
                                                    () => {
                                                        if (onSubmodelSelectClick) onSubmodelSelectClick(layerItem.id);
                                                    }
                                                }
                                                onOtherSubmodelChooseClick={
                                                    () => {
                                                        if (onOtherSubmodelChooseClick) onOtherSubmodelChooseClick(layerItem.id);
                                                    }
                                                }
                                                onSubmodelNameClick={
                                                    () => {
                                                        if (onSubmodelNameClick) onSubmodelNameClick(layerItem.id);
                                                    }
                                                }
                                                onSubmodelNameCancelClick={
                                                    () => {
                                                        if (onSubmodelNameCancelClick) onSubmodelNameCancelClick(layerItem.id);
                                                    }
                                                }
                                                onSubmodelNameSaveClick={
                                                    (name) => {
                                                        if (onSubmodelNameSaveClick) onSubmodelNameSaveClick(layerItem.id, name);
                                                    }
                                                }
                                            />
                                        )
                                    )
                                }
                                <div className='text-center my-1'>
                                    <CMSButton text='+ Elem hozzáadása' type='blue' onClick={() => handleLayerItemAddClick(layer.id)} />
                                </div>
                            </AccordionBody>
                        </AccordionItem>
                    ))
                }
            </Accordion>
        
            <CMSButton
                text='+ Réteg hozzáadása'
                type='pink'
                style={{ marginTop: '10px', width: '100%' }}
                onClick={handleAddNewLayerClick}
            />
        </div>
    );
};